<glxy-form-field *ngIf="!viewOnly">
  <textarea
    matInput
    #textFocus
    [formControl]="formControl"
    placeholder="{{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.EMPTY_NOTES' | translate }}"
    matTextareaAutosize
    matAutosizeMinRows="2"
    matAutosizeMaxRows="10"
  ></textarea>
  @switch (noteType) {
    @case ('customer') {
      <glxy-hint>
        {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.CUSTOMER_NOTES_INFO' | translate }}
      </glxy-hint>
    }
    @case ('administrator') {
      <glxy-hint>
        {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.ADMINISTRATIVE_NOTES_INFO' | translate }}
      </glxy-hint>
    }
  }
</glxy-form-field>

<div *ngIf="viewOnly">
  <div *ngIf="!!existingNotes; else noNotes" class="notes">
    {{ existingNotes }}
  </div>
  <ng-template #noNotes>
    <div class="no-notes">
      {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.EMPTY_NOTES' | translate }}
    </div>
  </ng-template>
</div>
